import { render, staticRenderFns } from "./addEmailFields.vue?vue&type=template&id=365c0904&scoped=true&"
import script from "./addEmailFields.vue?vue&type=script&lang=js&"
export * from "./addEmailFields.vue?vue&type=script&lang=js&"
import style0 from "./addEmailFields.vue?vue&type=style&index=0&id=365c0904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c0904",
  null
  
)

export default component.exports